import { createContext, useCallback, useContext, useMemo } from 'react';
import ObjectiveCycleDto from '../../../types/ObjectiveCycleDto';
import useSearchParam from './useSearchParam';

interface Context {
    cycles: ObjectiveCycleDto[];
    setCycles(cycles: ObjectiveCycleDto[]): void;
}

export const ObjectiveCycleSelectContext = createContext<Context>({
    cycles: [],
    setCycles: () => {},
});

export default function useObjectiveCycleSelectContext(initialCycleId?: string) {
    const { cycles, setCycles } = useContext(ObjectiveCycleSelectContext);
    const [cycleId, setCycleId] = useSearchParam<string | undefined>(
        'cycle',
        initialCycleId || cycles[0]?.id,
        p => p ?? undefined,
        c => c
    );
    const selectedCycle = useMemo(() => cycles?.find(c => c.id === cycleId), [cycleId, cycles]);
    const setSelectedCycle = useCallback((cycle: ObjectiveCycleDto) => setCycleId(cycle.id), [setCycleId]);
    return {
        cycles,
        setCycles,
        selectedCycle,
        setSelectedCycle,
    };
}
